import {Component, OnInit, DestroyRef, inject} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {EventsManager} from '../../events/events.manager';
import {ActivatedRoute} from '@angular/router';
import {SmartSearchConfig} from '@wellfit/wf-plans-services';
import {environment} from 'src/environments/environment';
import {BenefitPlanTemplateModel} from '../../models/plans.model';
import {GroupCodeUtility} from '../../utils/group-code.utility';

@Component({
  selector: 'app-ancillary-search',
  templateUrl: './ancillary-search.component.html',
  styleUrls: ['./ancillary-search.component.scss'],
  standalone: false
})

export class AncillarySearchComponent implements OnInit {
  private _destroyRef: DestroyRef = inject(DestroyRef);
  private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private _eventsManager: EventsManager = inject(EventsManager);

  private _ancillaryCodes: string = '';
  public isConfigReady: boolean = false;
  public searchConfig: SmartSearchConfig = {
    bootstrapVersion: '4',
    environment: (environment.smartSearchEnvironment === 'production') ? 'production' : 'staging',
    memberId: 0,
    isMember: false,
    groupCode: ''
  };

  public ngOnInit(): void {
    window.scrollTo(0, 0);

    this._activatedRoute.queryParams
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(params => {
        const groupCodeFromQuery = params['groupCode'];

        if (groupCodeFromQuery) {
          this._configureSearchWithGroupCode(groupCodeFromQuery);
        } else {
          this._configureSearchFromEventsManager();
        }
      });
  }

  private _configureSearchWithGroupCode(groupCode: string): void {
    this.searchConfig = {
      memberId: 0,
      isMember: false,
      environment: (environment.smartSearchEnvironment === 'production') ? 'production' : 'staging',
      bootstrapVersion: '4',
      groupCode: groupCode
    };

    this._setConfigReady();
  }

  private _configureSearchFromEventsManager(): void {
    const planDetailInfo = this._eventsManager.planDetailInfo;

    if (planDetailInfo && planDetailInfo.templateId) {
      const template = this._eventsManager.officeInfo?.benefitPlanTemplates?.find((template: BenefitPlanTemplateModel): boolean =>
        template.benefitPlanTemplateId == planDetailInfo.templateId
      );

      this._ancillaryCodes = template?.ancillaryBenefits || '';

      const groupCode: string = GroupCodeUtility.determineGroupCode(this._ancillaryCodes);

      this.searchConfig = {
        memberId: 0,
        isMember: false,
        environment: environment.production ? 'production' : 'staging',
        bootstrapVersion: '4',
        groupCode: groupCode
      };
    }

    this._setConfigReady();
  }

  private _setConfigReady(): void {
    setTimeout(() => {
      this.isConfigReady = true;
    }, 100);
  }
}
